<template>
    <div>
        <CCol sm="12">
            <CCard>
                <CCardBody class="d-flex flex-column">
                    <div class="d-flex mb-2 justify-content-end align-items-start">
                        <!-- Title -->
                        <span class="flex-grow-1" v-if="name"><b>{{ $t('memberIntro') }}</b> {{name}}</span>
                        <!-- Language dropdown -->
                        <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                    </div>
                    <div class="d-flex flex-wrap">
                        <!-- Photo -->
                        <div role="group" class="form-group col-12 col-lg-6">
                            <GalleryPicker class="gallery-picker" v-model="testimonial.photo" :ratioWidth="1" :ratioHeight="1" v-bind:class="{'is-invalid': genericValidator(testimonial.photo) === false || errorValidator('Photo') === false }" :max="1"></GalleryPicker>
                        </div>
                        <div class="col-12 col-lg-6">
                            <!-- name -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('nameMandatory') }}</label>
                                <CInput type="text" v-model="testimonial.name" :invalid-feedback="errorOutput['Name']" :is-valid="genericValidator(testimonial.name) && errorValidator('Name')"></CInput>
                            </div>
                            <!-- Titles -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('titleMandatory') }}</label>
                                <CInput type="text" v-model="testimonial.titles[currentLanguage.key]" :invalid-feedback="errorOutput['Titles']" :is-valid="genericValidator(testimonial.titles) && errorValidator('Titles')"></CInput>
                            </div>
                            <!-- rating -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('ratingMandatory') }}</label>
                                <CInput type="text" v-model="testimonial.rating" :invalid-feedback="errorOutput['Rating']" :is-valid="genericValidator(testimonial.rating) && errorValidator('Rating')"></CInput>
                            </div>
                            <!-- Description -->
                            <div role="group" class="form-group">
                                <label class=""> {{ $t('descriptionMandatory') }}</label>
                                <textarea class="form-control" v-model="testimonial.descriptions[currentLanguage.key]" :class="{'is-invalid': genericValidator(testimonial.descriptions) === false || errorValidator('Descriptions') == false }" cols="30" rows="10"></textarea>
                                <div v-if="errorOutput['Descriptions']" class="invalid-feedback">{{errorOutput['Descriptions']}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- Action button + submitting -->  
                    <div role="group" class="form-group col-12 d-flex justify-content-end">
                        <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                        <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                    </div>
                    <!-- Loading -->
                    <FormLoading v-if="loading"></FormLoading>
                </CCardBody>
            </CCard>
        </CCol>
        <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
    </div>
</template>
     
<script>
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import Testimonial from "@/classes/Testimonial";
import { mapState } from 'vuex'
import LanguageDropdown from "@/controls/LanguageDropdown.vue";
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import GalleryPicker from '@/controls/GalleryPicker.vue'
import FormLoading from '@/controls/FormLoading.vue'
import { API_HELPER } from "@/helpers/api.js";
    
export default {
    components: { LanguageDropdown, ConfirmationPopUp, GalleryPicker, FormLoading },
    props:{    
        baseTestimonial:
        {
            type: Object,
            default: null,
        },
        baseTestimonialName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            triedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            testimonial: new Testimonial({}, {}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:""
        }
    },
    mounted: function()
    {
        this.resetTestimonial();
    },
    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate multilanguage fields
            for (const [key, value] of Object.entries(this.testimonial.titles)) { if(!value) { result['Titles'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.testimonial.descriptions)) { if(!value) { result['Descriptions'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        ...mapState('testimonials', ['postTestimonialOutput']),
        ...mapState('testimonials', ['putTestimonialsOutput']),
        name: function()
        {
            return this.baseTestimonial || this.baseTestimonialName ? (this.baseTestimonial ? this.baseTestimonial.name : this.baseTestimonialName) : null;
        }
    },
    methods:{
        resetTestimonial(){
            if(!this.baseTestimonial)
            {
                var titles = {}; var descriptions = {}
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key] = ""; descriptions[language.key] = "" });

                this.testimonial = new Testimonial(titles, descriptions);
            }
            else
            {
                this.testimonial = deepClone(new Testimonial, this.baseTestimonial);
                this.testimonial.photo = {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.testimonial.photoPath])};     
            }
        },
        submitClicked(){
            this.triedSubmit = true;
            // Emit event
            if(this.testimonial.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.testimonial);
            }
        },
        genericValidator,
        errorValidator,
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "ListTestimonials" });
        },
    },
    watch:
    {
        postTestimonialOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        putTestimonialsOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        baseTestimonial: function()
        {
            this.resetTestimonial();
        },
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
}
</script> 
     
<style scoped>
.showDropdown {
    display: block !important;
}
    
.input-group-append {
    height: fit-content;
}
    
img {
    width: 50%;
    height: 50%;
}
    
</style>